import axios from "../../../utils/axios";
import { handleError } from "../../../utils/common-utils";

export const fetchCurrencyWallet = async (currency) => {
  return await axios.get(`/payments/wallet/${currency}/`);
};

export const performWalletTransaction = ({
  requestDetails,
  onSuccess,
  onFailure,
}) => {
  axios
    .post("/payments/wallet/debit", { ...requestDetails })
    .then(({ data }) => {
      onSuccess(data.id);
      
    })
    .catch((error) => {
      const message = handleError(error);
      onFailure(message);
    });
};
